import { atom, useAtomValue, useSetAtom } from "jotai";
import { BlockRecord } from "models/view-models/block-record";

const blocksAtom = atom<BlockRecord[]>([]);
const activeBlockIdAtom = atom<number | undefined>();

export const usePageBlockState = () => {
    const blocks = useAtomValue(blocksAtom);
    const activeBlockId = useAtomValue(activeBlockIdAtom);
    const activeBlock = blocks.find((block) => block.id === activeBlockId);
    return {
        blocks,
        activeBlock,
        setBlocks: useSetAtom(blocksAtom),
        setActiveBlockById: useSetAtom(activeBlockIdAtom),
    };
};
